import Anchor from "atoms/anchors/anchor";
import React from "react";
import logo from "assets/images/nfpa-link-color.png";
import { siteMap } from "internal-sitemap";
import ProfileOrUnauthenticatedMenu from "organisms/profile/profile-or-unauthenticated-menu";
import { SHARE_RECIPIENT_BASE_CLASS } from "templates/share-space-recipient-layouts/share-space-recipient-layout";

const BASE_CLASS = "c-unauthorized-header";

const NonsubscriberHeader = () => {
    return (
        <header
            className={`${SHARE_RECIPIENT_BASE_CLASS}__header -unauthorized`}>
            <Anchor
                to={siteMap.home}
                ariaLabel="Home"
                cssClassName={`${BASE_CLASS}__logoWrapper`}>
                <img src={logo} alt="Home" className={`${BASE_CLASS}__logo`} />
            </Anchor>
            <div className={`${BASE_CLASS}__buttonWrapper`}>
                <ProfileOrUnauthenticatedMenu />
            </div>
        </header>
    );
};

export default NonsubscriberHeader;
